import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { BridgeMode } from '@hg-com/xwc-js-bridge/dist/native-app.service';

@Component({
  selector: 'app-status-indicator',
  templateUrl: './status-indicator.component.html',
  styleUrls: ['./status-indicator.component.scss'],
})
export class StatusIndicatorComponent implements OnInit {
  online = true;
  private subscription: Subscription = new Subscription();

  constructor(
    private nativeIntegrationService: NativeIntegrationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.nativeIntegrationService.native.mode > BridgeMode.Mock) {
      console.log('status indicator');
      console.log(this.nativeIntegrationService.native.mode);

      this.nativeIntegrationService.checkConnection();
      const networkSub =
        this.nativeIntegrationService.network.networkStateChange.subscribe(
          (state) => {
            console.log('NETWORK Subscription');
            console.log(state);
            this.nativeIntegrationService.checkConnection();
          }
        );
      this.subscription.add(networkSub);
      this.nativeIntegrationService.online$.subscribe((online) => {
        if (online) {
          this.online = true;
        } else {
          this.online = false;
        }
      });
    }
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
